import { create } from "zustand";
import { persist } from "zustand/middleware";


interface PaymentSquareConfigState {
  isEnabled: boolean;
  setEnabled: (isEnabled: boolean) => void;
  squareTerminalId: string | null;
  setSquareTerminalId: (squareTerminalId: string | null) => void;
}


const usePaymentSquareConfigStore = create<PaymentSquareConfigState>()(
  persist(
    (set) => ({
      isEnabled: false,
      setEnabled: (isEnabled) => set({ isEnabled }),
      squareTerminalId: null,
      setSquareTerminalId: (squareTerminalId) => set({ squareTerminalId }),
    }),
    {
      name: "payment-square-config",
      getStorage: () => localStorage,
    }
  ),
);

export default usePaymentSquareConfigStore;